// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/giorgetti.scss
// module id = 1341
// module chunks = 156